/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION : STYLES --------------- ++++++++++ */
export default theme => ({
  sectiondescription: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h5': {
      display: props => !!props.main ? 'block' : 'none',
      textTransform: props => !!props.main ? 'capitalize' : 'none'
    },
    '& h6': {
      display: props => !!props.additional ? 'block' : 'none'
    }
  }
});
